import ReactDom from 'react-dom';

import BackIconImage from '@assets/svg/back-icon.svg';
import { useState } from 'react';
import { ITag } from '@models/Tag.model';
import { TagInfoBody } from './components';

import { Overlay, Container, SpacingDivider, Back } from './TagInfo.styles';

interface Props {
  open: boolean;
  onClose: () => void;
  tag?: Pick<ITag, 'id' | 'name' | 'description'> & {
    tagCategory?: Pick<NonNullable<ITag['tagCategory']>, 'name'>;
  };
}
export const TagInfo = ({ tag, open, onClose }: Props) => {
  const portalDiv = document.getElementById('portal');

  const [topic, setTopic] = useState<'user' | null>(null);

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            {topic && (
              <>
                <Back
                  src={BackIconImage}
                  alt="back"
                  onClick={() => setTopic(null)}
                />
                <SpacingDivider />
              </>
            )}
            {tag && (
              <TagInfoBody tag={tag} onClose={onClose} setTopic={setTopic} />
            )}
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
